export default "__VITE_ASSET__289ff271__"